module.exports = __webpack_public_path__ + "static/giftSettingImage-fee014b6f3eea7eeee9b72e95c13ae04.png";